ixModuleRouting(
    "impactx.cscontract",
    {
        "/cscmain/:id/:preSetId?": {
            template: "<ixa-cscontract-main-data></ixa-cscontract-main-data>",
            templateUrl: "modules/cscontract/templates/cscontractmaindata.html",
            process: "ViewCSC",
            controller: "CSContractMainDataCtrl",
            controllerAs: "csContractMainDataCtrl",
            workspace: "content",
        },
        "/cscsettings/:id/:preSetId?": {
            template: "<ixa-cscontract-settings-data></ixa-cscontract-settings-data>",
            templateUrl:
                "modules/cscontract/templates/cscontractsettingsdata.html",
            process: "ViewCSC",
            controller: "CSContractSettingsDataCtrl",
            controllerAs: "csContractSettingsDataCtrl",
            workspace: "content",
        },
        "/contract/0/:type/:buyerComId/:supplierComId/:contactBuyerId/:catalogId/:masterContractId/:isModelContract":
            {
                template: "<ixa-cscontract-main-data></ixa-cscontract-main-data>",
                templateUrl:
                    "modules/cscontract/templates/cscontractmaindata.html",
                process: "ViewCSC",
                controller: "CSContractMainDataCtrl",
                controllerAs: "csContractMainDataCtrl",
                workspace: "content",
            },
        "/cscontractlist/:preSetId?": {
            template: "<ixa-cscontract-basic-list></ixa-cscontract-basic-list>",
            templateUrl:
                "modules/cscontract/templates/cscontractbasiclist.tmpl.html",
            process: "ListCSC",
            controller: "CSContractBasicListCtrl",
            controllerAs: "cscontractBasicListCtrl",
            workspace: "content",
        },
        "/cscontractmodellist": {
            template: "<ixa-cscontract-model-list></ixa-cscontract-model-list>",
            templateUrl:
                "modules/cscontract/templates/cscontractmodellist.tmpl.html",
            process: "ListCSC",
            controller: "CSContractModelListCtrl",
            controllerAs: "cscontractModelListCtrl",
            workspace: "content",
        },
        "/cscontractlist/tender/:tenderId": {
            template: "<ixa-cscontract-basic-list-for-tender></ixa-cscontract-basic-list-for-tender>",
            templateUrl:
                "modules/cscontract/templates/cscontractbasiclist.tmpl.html",
            process: "ListCSC",
            controller: "CSContractBasicListForTenderCtrl",
            controllerAs: "cscontractBasicListCtrl",
            workspace: "content",
        },
        "/cscontractmodellist/tender/:tenderId": {
            template: "<ixa-cscontract-model-list-for-tender></ixa-cscontract-model-list-for-tender>",
            templateUrl:
                "modules/cscontract/templates/cscontractmodellist.tmpl.html",
            process: "ListCSC",
            controller: "CSContractModelListForTenderCtrl",
            controllerAs: "cscontractModelListCtrl",
            workspace: "content",
        },
        "/cscontractlist/lot/:lotId": {
            template:"<ixa-cscontract-basic-list-for-lot></ixa-cscontract-basic-list-for-lot>",
            templateUrl:
                "modules/cscontract/templates/cscontractbasiclist.tmpl.html",
            process: "ListCSC",
            controller: "CSContractBasicListForLotCtrl",
            controllerAs: "cscontractBasicListCtrl",
            workspace: "content",
        },
        "/cscontractmodellist/lot/:lotId": {
            template: "<ixa-cscontract-model-list-for-lot></ixa-cscontract-model-list-for-lot>",
            templateUrl:
                "modules/cscontract/templates/cscontractmodellist.tmpl.html",
            process: "ListCSC",
            controller: "CSContractModelListForLotCtrl",
            controllerAs: "cscontractModelListCtrl",
            workspace: "content",
        },
        "/csclimitlist": {
            template:"<ixa-csccontract-limit-list></ixa-csccontract-limit-list>",
            templateUrl:
                "modules/cscontract/templates/cscontractlimitlist.tmpl.html",
            process: "CSContract",
            controller: "CSContractLimitListCtrl",
            controllerAs: "cscontractLimitListCtrl",
            workspace: "content",
        },
        "/csclimit/:id/:preSetId?": {
            template: "<ixa-csccontract-limit-view></ixa-csccontract-limit-view>",
            templateUrl:
                "modules/cscontract/templates/cscontractlimitview.tmpl.html",
            process: "CSContract",
            controller: "CSContractLimitViewCtrl",
            controllerAs: "cscontractLimitViewCtrl",
            workspace: "content",
        },
        "/cscoutlets/:cscId/:preSetId?": {
            template: '<ixa-cscoutlets></ixa-cscoutlets>',
            templateUrl: "modules/cscontract/templates/cscoutlets.html",
            process: "EditCSCOutlets",
            controller: "CSCOutletsCtrl",
            controllerAs: "cscOutletsCtrl",
            workspace: "content",
        },
        "/cscnumberingschemas/:cscId/:preSetId?": {
            template: '<ixa-cscnumberingschemas></ixa-cscnumberingschemas>',
            templateUrl:
                "modules/cscontract/templates/cscnumberingschemas.html",
            process: "EditCSCNumberingSchemas",
            controller: "CSCNumberingSchemasCtrl",
            controllerAs: "cscNumberingSchemasCtrl",
            workspace: "content",
        },
        "/cscbudgets/:cscId/:preSetId?": {
            template: '<ixa-cscbudgets></ixa-cscbudgets>',
            templateUrl: "modules/cscontract/templates/cscbudgets.html",
            process: "EditCSCBudgets",
            controller: "CSCBudgetsSchemasCtrl",
            controllerAs: "cscBudgetsSchemasCtrl",
            workspace: "content",
        },
        "/cscaddresses/:cscId/:preSetId?": {
            template: "<ixa-cscaddresses></ixa-cscaddresses>",
            templateUrl: "modules/cscontract/templates/cscaddresses.tmpl.html",
            process: "EditCSCAddresses",
            controller: "CSCAddressesCtrl",
            controllerAs: "cscAddressesCtrl",
            workspace: "content",
        },
        "/cscorders/:cscId/:preSetId?": {
            template: "<ixa-cscorders></ixa-cscorders>",
            templateUrl: "modules/cscontract/templates/cscorders.tmpl.html",
            process: "EditCSCOrders",
            controller: "CSCOrdersCtrl",
            controllerAs: "cscOrdersCtrl",
            workspace: "content",
        },
        "/csccomments/:cscId/:preSetId?": {
            template: "<ixa-csccomments></ixa-csccomments>",
            templateUrl: "modules/cscontract/templates/csccomments.tmpl.html",
            process: "EditCSCComments",
            controller: "CSCCommentsCtrl",
            controllerAs: "cscCommentsCtrl",
            workspace: "content",
        },
        "/cscconditions/:id/:preSetId?": {
            template: "<ixa-cscontract-conditions-data></ixa-cscontract-conditions-data>",
            templateUrl:
                "modules/cscontract/templates/cscontractconditionsdata.html",
            process: "EditCSCConditions",
            controller: "CSContractConditionsDataCtrl",
            controllerAs: "csContractConditionsDataCtrl",
            workspace: "content",
        },
        "/cscrfqc/:id/:preSetId?": {
            template: "<ixa-cscontract-rfqc-data></ixa-cscontract-rfqc-data>",
            templateUrl: "modules/cscontract/templates/cscontractrfqcdata.html",
            process: "ViewCSC",
            controller: "CSContractRFQCDataCtrl",
            controllerAs: "csContractRFQCDataCtrl",
            workspace: "content",
        },
        "/csctolerance/:cscId/:preSetId?": {
            template: "<ixa-csctolerance-dialog></ixa-csctolerance-dialog>",
            templateUrl: "modules/cscontract/templates/csctolerance.tmpl.html",
            process: "EditCSCTolerance",
            controller: "CSCToleranceDialogCtrl",
            controllerAs: "cscToleranceDialogCtrl",
            workspace: "content",
        },
        "/cscgrn/:id/:preSetId?": {
            template: "<ixa-cscontract-grn-data></ixa-cscontract-grn-data>",
            templateUrl: "modules/cscontract/templates/cscgrn.tmpl.html",
            process: "EditCSCGrn",
            controller: "CSContractGrnDataCtrl",
            controllerAs: "csContractGrnDataCtrl",
            workspace: "content",
        },
        "/cscproductgroups/:id/:preSetId?": {
            template: "<ixa-cscontract-product-groups-data></ixa-cscontract-product-groups-data>",
            templateUrl:
                "modules/cscontract/templates/cscontractproductgroupsdata.html",
            process: "EditCSCProductGroups",
            controller: "CSContractProductGroupsDataCtrl",
            controllerAs: "csContractProductGroupsDataCtrl",
            workspace: "content",
        },
        "/cscinterface/:id/:preSetId?": {
            template: "<ixa-cscontract-interface-data></ixa-cscontract-interface-data>",
            templateUrl:
                "modules/cscontract/templates/cscontractinterfacedata.html",
            process: "ViewCSC",
            controller: "CSContractInterfaceDataCtrl",
            controllerAs: "csContractInterfaceDataCtrl",
            workspace: "content",
        },
        "/csccommonlist": {
            template: "<ixa-csccommon-list></ixa-csccommon-list>",
            templateUrl: "modules/cscontract/templates/csccommonlist.tmpl.html",
            process: "ViewCSC",
            controller: "CSCCommonListCtrl",
            controllerAs: "cscCommonListCtrl",
            workspace: "content",
        },
        "/csccommonrelationlist/:id": {
            template: "<ixa-csccommon-relation-list></ixa-csccommon-relation-list>",
            templateUrl:
                "modules/cscontract/templates/csccommonrelationlist.tmpl.html",
            process: "ViewCSC",
            controller: "CSCCommonRelationListCtrl",
            controllerAs: "cscCommonRelationListCtrl",
            workspace: "content",
        },
        "/csccommonrelation/:id/:csccommonId": {
            template: "<ixa-csccommon-relation-detail></ixa-csccommon-relation-detail>",
            templateUrl:
                "modules/cscontract/templates/csccommonrelation.tmpl.html",
            process: "ViewCSC",
            controller: "CSCCommonRelationCtrl",
            controllerAs: "cscCommonRelationCtrl",
            workspace: "content",
        },
        "/csccatalogrelation/:id/:preSetId?": {
            template: "<ixa-catalog-relation-dialog></ixa-catalog-relation-dialog>",
            process: "ViewCSC",
            workspace: "content",
        },
    },
    ["ngRoute", "impactx.list"]
);
